import config from '../aws-exports';
import Amplify, { API } from 'aws-amplify';
import { TeamData } from './data-service';

Amplify.configure(config);
//API.configure(config.amplify.API);

const API_NAME = 'photos';
const TEAM_PATH = '/team-update';

async function getHeaders(): Promise<any> {
    const headers: any = {};
    return headers;
}

class TeamUpdate {
    result?: string;
    minor_premiers?: boolean;
    team_image_id?: string;
    players?: Array<any>;
    blurb?: string;
}

export async function updateTeam(
    year: string, grade: string, team_number: string, details: TeamUpdate): Promise<string> {
    // Submit the metadata and get the presigned URL to upload to S3
    const team = {
        year: year,
        grade: grade,
        team_number: team_number,
        result: details.result,
        minor_premiers: details.minor_premiers,
        team_image_id: details.team_image_id,
        blurb: details.blurb
    };
    const body = {
        team: team
    };
    const initiateResult = await API.put(
        API_NAME, TEAM_PATH, { body: body, headers: await getHeaders() },
    );
    console.log(initiateResult);
    return initiateResult.team_id;
}

export async function getTeam(id: string): Promise<TeamData> {
    const getResult = await API.get(
        API_NAME, `${TEAM_PATH}?id=${id}`, { headers: await getHeaders() },
    );
    console.log(getResult);
    return getResult.team;
}

export async function deleteTeam(id: string): Promise<TeamData> {
    const getResult = await API.del(
        API_NAME, `${TEAM_PATH}?id=${id}`, { headers: await getHeaders() },
    );
    console.log(getResult);
    return getResult.team;
}

